import { useQuery } from "@tanstack/react-query";
import { getClientsByProject } from "../../api/apiCallManager";

const useProjectWiseClientList = () => {
  return useQuery({
    queryKey: ["clientList_Status"],
    queryFn: getClientsByProject,
  });
};

export default useProjectWiseClientList;
